import { render, staticRenderFns } from "./buscador-persona-dual.vue?vue&type=template&id=66aea394&scoped=true&"
import script from "./buscador-persona-dual.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-persona-dual.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-persona-dual.vue?vue&type=style&index=0&id=66aea394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aea394",
  null
  
)

export default component.exports